/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./compat-threatmetrix.component";
import * as i2 from "../@freelancer/threatmetrix/threatmetrix.service";
var styles_CompatThreatmetrixComponent = [];
var RenderType_CompatThreatmetrixComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_CompatThreatmetrixComponent, data: {} });
export { RenderType_CompatThreatmetrixComponent as RenderType_CompatThreatmetrixComponent };
export function View_CompatThreatmetrixComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_CompatThreatmetrixComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "webapp-compat-threatmetrix", [], null, null, null, View_CompatThreatmetrixComponent_0, RenderType_CompatThreatmetrixComponent)), i0.ɵdid(1, 114688, null, 0, i1.CompatThreatmetrixComponent, [i2.ThreatmetrixService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CompatThreatmetrixComponentNgFactory = i0.ɵccf("webapp-compat-threatmetrix", i1.CompatThreatmetrixComponent, View_CompatThreatmetrixComponent_Host_0, {}, {}, []);
export { CompatThreatmetrixComponentNgFactory as CompatThreatmetrixComponentNgFactory };
